<template>
    <article>
        <div class="table_card mb-5">
            <div class="table_card__head">
                <v-layout row wrap fill-height>
                    <v-flex xs12 lg6 class="head_contain">
                        <p class="table_card__head--title">
                            Geolocalización de Usuarios en Web
                        </p>
                    </v-flex>
                    <v-flex xs12 lg6 class="filter_options">
                        <div
                            class="buttom_reload"
                            @click="getUsersGeolocations()"
                        >
                            <img src="@/assets/img/icons/refresh-icon.svg">
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <div>
                <l-map style="height: 300px" :zoom="zoom" :center="center">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                        <l-marker
                        v-for="item in web_markers"
                        :key="'marker-' + item"
                        :lat-lng="item"
                        ></l-marker>
                </l-map>
            </div>
        </div>

        <div class="table_card">
            <div class="table_card__head">
                <v-layout row wrap fill-height>
                    <v-flex xs12 lg6 class="head_contain">
                        <p class="table_card__head--title">
                            Geolocalización de Usuarios en Móvil
                        </p>
                    </v-flex>
                    <v-flex xs12 lg6 class="filter_options">
                        <div
                            class="buttom_reload"
                            @click="getUsersGeolocations()"
                        >
                            <img src="@/assets/img/icons/refresh-icon.svg">
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <div>
                <l-map style="height: 300px;" :zoom="zoom" :center="center">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-marker
                    v-for="item in mobile_markers"
                    :key="'marker-' + item"
                    :lat-lng="item"
                    ></l-marker>
                </l-map>
            </div>
        </div>
    </article>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 10,
            center: [4.7083188, -74.0543122],
            web_markers: [],
            mobile_markers: [],
        };
    },
    mounted(){
        this.getUsersGeolocations()
    },
    methods:{
        getUsersGeolocations(){
            try {
                this.$http.get('users/get_activity_log_info', {
                    params:{
                        platform: ""
                    },
                    headers:
                    {
                        "X-Device-ID" : this.getDeviceId(),
                        "Authorization" : 'Bearer ' + this.getUserToken()
                    },
                }).then(function(response){
                    let web_geolocations = [];
                    let mobile_geolocations = [];
                    response.body.geolocations.web_geolocations.map(function(value, key) {
                        web_geolocations.push([value.lat, value.long]);
                    });       
                    response.body.geolocations.mobile_geolocations.map(function(value, key) {
                        mobile_geolocations.push([value.lat, value.long]);
                    });
                    this.web_markers = web_geolocations
                    this.mobile_markers = mobile_geolocations                    
                    if(response.body.meta != undefined && response.body.meta != null){
                        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                        this.checkToken(response.body.meta.authentication_token)
                        }
                    }
                }, function(response){
                    if(response.body.meta != undefined && response.body.meta != null){
                        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                            this.checkToken(response.body.meta.authentication_token)
                        }
                    }
                })
            } catch (e) {
                console.log(e.message)
            }
        }
    }
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/views/users/UsersGeolocations.vue